import type { StepType } from "@reactour/tour";
import { text } from "@quickpoint.me/shared";
import TourStepContent from "../../wrapper";
import { fireClearCodeEvent } from "../../../editor/events";
import { typeSomeText } from "../../common";

const actionText = [
	"How do you make text bold, underlined or italicized?",
	"How do you **make text bold**, underlined or italicized?",
	"How do you **make text bold**, __underlined__ or ''italicized?''",
];

const formatting: StepType[] = [
	{
		selector: "window",
		position: "center",
		content: () => (
			<TourStepContent description={() => <strong>{text.tourSteps.formattingTitle}</strong>} />
		),
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent description={() => text.tourSteps.formattingIntro} />
		),
		position: "center",
		action: () => {
			fireClearCodeEvent();
			typeSomeText({ text: actionText[0] });
		},
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.formattingBoldPrefix}{" "}
						<span className="qp-tour-modifier">**</span>.
					</span>
				)}
			/>
		),
		action: () => {
			fireClearCodeEvent();
			typeSomeText({ text: actionText[1] });
		},
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						Use <span className="qp-tour-modifier">__</span> {text.tourSteps.formattingUnderlineMiddle}
						<span className="qp-tour-modifier">''</span> {text.tourSteps.formattingItalicSuffix}
					</span>
				)}
			/>
		),
		action: () => {
			fireClearCodeEvent();
			typeSomeText({ text: actionText[2] });
		},
	},
	{
		selector: "#landscape-viewer",
		content: () => <TourStepContent description={() => text.tourSteps.formattingVoila} />,
	},
];

export default formatting;
